import React from 'react';

import { Button as StyledButton, Img } from './styles';

interface Props {
  onClick: (event: React.MouseEvent) => void;
}

const Button = (props: Props) => (
  <StyledButton {...props}>
    <Img src="/images/trash-circle.svg" alt="icon" />
  </StyledButton>
);

export default Button;
